import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[560px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20abstract%20composition%20with%20soft%20gradients%20in%20coral%20and%20deep%20amber%20tones%2C%20organic%20flowing%20shapes%2C%20modern%20minimal%20design%2C%20no%20text%2C%20smooth%20color%20transitions%2C%20elegant%20and%20premium%20aesthetic%2C%20warm%20inviting%20atmosphere&width=1920&height=1080&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-5xl font-black text-background-50 mb-4 leading-tight">
          你有料，我们<span className="text-primary-400">有平台</span>
        </h2>
        <p className="text-background-50/70 text-sm md:text-lg mb-8 leading-relaxed">
          手握独家爆料？发现不为人知的真相？<br className="hidden sm:block" />
          立即联系我们，让你的声音被千万人听见。
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 rounded-full text-base font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer group"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-send-plane-fill text-sm"></i>
          </span>
          我要爆料
          <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
        </Link>
      </div>
    </section>
  );
}